import React, { useState } from 'react';
import { 
  TrophyIcon,
  StarIcon,
  UserIcon,
  XMarkIcon
} from '@heroicons/react/24/outline';

const Team = () => {
  const [selectedCoach, setSelectedCoach] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openCoachModal = (coach) => {
    setSelectedCoach(coach);
    setIsModalOpen(true);
  };

  const closeCoachModal = () => {
    setSelectedCoach(null);
    setIsModalOpen(false);
  };

  const coaches = [
    {
      name: "Tang Ngai Kin",
      role: "Coach Emeritus",
      image: "https://firebasestorage.googleapis.com/v0/b/oldham-dashboard1.firebasestorage.app/o/coaches%2FcoachTang.jpg?alt=media",
      credentials: "Certified Athletics Coach, Former National Decathlon Record Holder",
      bio: "Coach Tang Ngai Kin is a distinguished former national athlete who brings unparalleled experience and expertise to Oldham Athletics. As a former Singapore national decathlon record holder and prominent multi-event athlete, Coach Tang competed across multiple disciplines including the 100m, long jump, shot put, and high jump, setting records at the National Schools Athletics Meet. His transition from elite athlete to accomplished coach at Anglo-Chinese School (Independent) has been marked by his ability to develop young talent through a combination of technical excellence and mentorship. Coach Tang's philosophy emphasizes the importance of strong work ethic combined with natural talent, and his athletes consistently achieve outstanding results under his guidance. As Coach in Charge of Oldham Athletics, he provides strategic leadership and coordination across the entire coaching team, ensuring that all coaches work together effectively to develop our athletes to their fullest potential.",
      achievements: [
        "Former Singapore National Decathlon Record Holder",
        "National Schools Athletics Meet High Jump Record Holder",
        "Multi-event specialist (100m, Long Jump, Shot Put, High Jump)",
        "Coach at Anglo-Chinese School (Independent)",
        "Athlete Development Specialist",
        "Coach in Charge of Oldham Athletics",
        "Emphasizes work ethic and natural talent development"
      ]
    },
    {
      name: "Shameer Ayub",
      role: "Coach\nProgram Coordinator",
      image: "https://firebasestorage.googleapis.com/v0/b/oldham-dashboard1.firebasestorage.app/o/coaches%2FcoachSham.jpeg?alt=media",
      credentials: "WA CECS Level 1, WA 1 Lecturer, SG Youth Coaching Course Level 1",
      bio: "A former Singapore national sprinter with an illustrious career that includes competing in the SEA Games, Asian Track Championships, and World Championships, Shameer brings a wealth of experience to the team. Known for his technical expertise and systematic approach, he has spent over a decade refining his coaching philosophy, focusing on performance optimization, technical excellence, and athlete development. His dedication to nurturing talent has helped athletes achieve personal bests and excel on both national and international stages.",
      achievements: [
        "Former Singapore National Sprinter",
        "Triple Gold Medalist in NSG 2000 (100m, 200m, 4x100m)",
        "Former National Junior Record Holder (100m: 10.60s, 200m: 21.50s)",
        "World Athletics Level 1 Lecturer",
        "SG Youth Coaching Course Level 1 & 2",
        "Coached athletes to podium finishes in NSG and international competitions"
      ]
    },
    {
      name: "Zorndrix Dass",
      role: "Coach",
      image: "https://firebasestorage.googleapis.com/v0/b/oldham-dashboard1.firebasestorage.app/o/coaches%2FcoachZorn.jpeg?alt=media",
      credentials: "WA CECS Level 1, SG-Coach Level 1 Theory, Certificate of participation in VPS course, Standard First Aid + AED Certified", 
      bio: "Committed to building strong fundamentals and creating a supportive training environment for all athletes.",
      achievements: [
        "Degree of Bachelor of Science (Sport Science & Management) with Honours at NTU",
      ]
    },
    {
      name: "Siva Gami Subrama",
      role: "Coach",
      image: "https://firebasestorage.googleapis.com/v0/b/oldham-dashboard1.firebasestorage.app/o/coaches%2FcoachSiva.jpeg?alt=media",
      credentials: "WA CECS Level 1",
      bio: "Mdm Siva brings dedication and expertise to the Oldham coaching team, focusing on athlete development and technical excellence. Her commitment to nurturing young talent and fostering a positive training environment makes her a valuable member of our coaching staff.",
      achievements: [
        "Athlete Development Specialist",
        "Technical Coaching Expert",
        "Youth Development Focus",
        "Team Support & Mentorship"
      ]
    },
    {
      name: "Kenneth Khing",
      role: "Coach",
      image: "https://firebasestorage.googleapis.com/v0/b/oldham-dashboard1.firebasestorage.app/o/coaches%2FcoachKenneth.jpeg?alt=media",
      credentials: "WA CECS Level 1",
      bio: "Kenneth's coaching philosophy is grounded in a diverse background spanning competitive running across all distances, sprint swimming at the World Masters level, and competitive dance instructorship — giving him a unique sensitivity to movement and technique. He blends this with a solid foundation in sports science and a deep study of middle- and long-distance training systems from Norway, Japan, the USA, and Africa. Kenneth has successfully coached both youth and senior athletes, guiding individuals from beginner levels to world-class competitions.",
      achievements: [
        "Degree in Sports Science & Management, Post-graduate diploma in Physical Education",
        "Former National Youth runner",
        "Versatile (100m: 11.63, 800m: 1.58.20, 5000m: 17.24.00 at 18 years old)",
        "Coached adult athletes to sub-3 hour marathons and several Hyrox champions"
      ]
    },
    {
      name: "Faris Wahab",
      role: "Coach",
      image: "https://firebasestorage.googleapis.com/v0/b/oldham-dashboard1.firebasestorage.app/o/coaches%2FcoachFaris.jpeg?alt=media",
      credentials: "Diploma in Sports Science & Management, WA CECS Level 1, AIC Advanced Coaching Certification System Level 1, ASCA Strength & Conditioning Coach Accreditation L1, Sg Coach Excellence Theory Level 2, NCAP Theory Level 1, NYSI Sg Youth Coaching Course Level 1 & 2, Risk Management in Sport Level 2, ISA Elderly Exercise Specialist Course",
      bio: "Coach Faris brings a wealth of experience and a strong academic background in sports science to the team. With extensive certifications in coaching, strength & conditioning, and sports management, Faris has successfully guided athletes across various age groups. His competitive achievements at the Asian Masters Athletics and World Masters Athletics demonstrate his dedication to excellence, while his coaching experience spans primary school to masters level, with a specialization in sprint and relay coaching.",
      achievements: [
        "Asian Masters Athletics Medalist",
        "Coach of MOE Pri/Sec School T&F and Cross Country CCA & School Teams",
        "Youth & Masters Performance Development Coach",
        "U13 & U18 Youth Development Coach",
        "Sprint & Relay Coaching Specialist"
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
      {/* Hero Section */}
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-oldham-blue/20 to-oldham-red/20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          <div className="text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              Meet the <span className="text-oldham-gold">Team</span>
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
              Our passionate coaches who make Oldham Athletics 
              a thriving community of excellence and camaraderie.
            </p>
          </div>
        </div>
      </div>

      {/* Coaches Section */}
      <div className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-white mb-6">
              Our <span className="text-oldham-gold">Coaching Team</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Experienced professionals dedicated to developing athletes at every level
            </p>
          </div>
          
          {/* Group coaches by role */}
          {(() => {
            const coachEmeritus = coaches.filter(c => c.role === 'Coach Emeritus');
            const leadershipTeam = coaches.filter(c => 
              c.role === 'Senior Head Coach' || c.role === 'Head Coach' || c.role === 'Coach\nProgram Coordinator'
            );
            const coachingTeam = coaches.filter(c => 
              !['Coach Emeritus', 'Senior Head Coach', 'Head Coach', 'Coach\nProgram Coordinator'].includes(c.role)
            );
            
            return (
              <div className="space-y-12">
                {/* Coach Emeritus */}
                {coachEmeritus.length > 0 && (
                  <div>
                    <h3 className="text-2xl font-bold text-oldham-gold mb-6 text-center border-b border-oldham-gold/30 pb-3">
                      Coach Emeritus
                    </h3>
                    <div className="flex flex-wrap justify-center gap-6">
                      {coachEmeritus.map((coach, index) => (
                        <div key={index} className="group relative">
                          <div 
                            className="bg-gray-800/30 rounded-lg p-6 transition-all duration-300 hover:bg-gray-800/50 hover:scale-105 hover:shadow-lg text-center cursor-pointer"
                            onClick={() => openCoachModal(coach)}
                          >
                            <div className="relative inline-block mb-4">
                              {coach.image && !coach.image.includes('placeholder-coach.jpg') ? (
                                <img 
                                  src={coach.image} 
                                  alt={coach.name}
                                  className="w-20 h-20 rounded-full object-cover"
                                />
                              ) : (
                                <div className="w-20 h-20 rounded-full bg-gray-700/50 flex items-center justify-center">
                                  <UserIcon className="w-10 h-10 text-gray-400" />
                                </div>
                              )}
                            </div>
                            <h3 className="text-sm font-semibold text-white mb-1">{coach.name}</h3>
                            <p className="text-gray-400 text-xs whitespace-pre-line">{coach.role}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Leadership Team */}
                {leadershipTeam.length > 0 && (
                  <div>
                    <h3 className="text-2xl font-bold text-oldham-gold mb-6 text-center border-b border-oldham-gold/25 pb-3">
                      Leadership Team
                    </h3>
                    <div className="flex flex-wrap justify-center gap-6">
                      {leadershipTeam.map((coach, index) => (
                        <div key={index} className="group relative">
                          <div 
                            className="bg-gray-800/30 rounded-lg p-4 transition-all duration-300 hover:bg-gray-800/50 hover:scale-105 hover:shadow-lg text-center cursor-pointer"
                            onClick={() => openCoachModal(coach)}
                          >
                            <div className="relative inline-block mb-3 mx-auto">
                              {coach.image && !coach.image.includes('placeholder-coach.jpg') ? (
                                <img 
                                  src={coach.image} 
                                  alt={coach.name}
                                  className="w-16 h-16 rounded-full object-cover"
                                />
                              ) : (
                                <div className="w-16 h-16 rounded-full bg-gray-700/50 flex items-center justify-center">
                                  <UserIcon className="w-8 h-8 text-gray-400" />
                                </div>
                              )}
                            </div>
                            <h3 className="text-sm font-semibold text-white mb-1">{coach.name}</h3>
                            <p className="text-gray-400 text-xs whitespace-pre-line">{coach.role}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Coaching Team */}
                {coachingTeam.length > 0 && (
                  <div>
                    <h3 className="text-2xl font-bold text-oldham-gold mb-6 text-center border-b border-oldham-gold/20 pb-3">
                      Coaching Team
                    </h3>
                    <div className="flex flex-wrap justify-center gap-6">
                      {coachingTeam.map((coach, index) => (
                        <div key={index} className="group relative">
                          <div 
                            className="bg-gray-800/30 rounded-lg p-4 transition-all duration-300 hover:bg-gray-800/50 hover:scale-105 hover:shadow-lg text-center cursor-pointer"
                            onClick={() => openCoachModal(coach)}
                          >
                            <div className="relative inline-block mb-3 mx-auto">
                              {coach.image && !coach.image.includes('placeholder-coach.jpg') ? (
                                <img 
                                  src={coach.image} 
                                  alt={coach.name}
                                  className="w-16 h-16 rounded-full object-cover"
                                />
                              ) : (
                                <div className="w-16 h-16 rounded-full bg-gray-700/50 flex items-center justify-center">
                                  <UserIcon className="w-8 h-8 text-gray-400" />
                                </div>
                              )}
                            </div>
                            <h3 className="text-sm font-semibold text-white mb-1">{coach.name}</h3>
                            <p className="text-gray-400 text-xs whitespace-pre-line">{coach.role}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            );
          })()}
        </div>
      </div>

      {/* Join Our Team Section */}
      <div className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Join Our <span className="text-oldham-gold">Team</span>
          </h2>
          <p className="text-xl text-gray-300 mb-8 leading-relaxed">
            Whether you're an aspiring athlete looking to develop your skills or an experienced 
            coach wanting to share your knowledge, we welcome passionate individuals to join our community.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/programmes"
              className="bg-oldham-gold text-gray-900 font-semibold py-4 px-8 rounded-lg hover:bg-oldham-gold/90 transition-all duration-300 transform hover:scale-105"
            >
              Become an Athlete
            </a>
            <a
              href="/contact"
              className="border-2 border-oldham-gold text-oldham-gold font-semibold py-4 px-8 rounded-lg hover:bg-oldham-gold hover:text-gray-900 transition-all duration-300"
            >
              Join as Coach
            </a>
          </div>
        </div>
      </div>

      {/* Coach Modal */}
      {isModalOpen && selectedCoach && (
        <div 
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          onClick={closeCoachModal}
        >
          <div 
            className="bg-gray-800/95 backdrop-blur-sm border border-gray-700/50 rounded-2xl p-6 w-full max-w-sm sm:max-w-lg lg:max-w-xl max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center space-x-4">
                <div className="relative">
                  {selectedCoach.image && !selectedCoach.image.includes('placeholder-coach.jpg') ? (
                    <img 
                      src={selectedCoach.image} 
                      alt={selectedCoach.name}
                      className="w-16 h-16 rounded-full object-cover border-4 border-oldham-gold/30"
                    />
                  ) : (
                    <div className="w-16 h-16 rounded-full bg-gray-700/50 flex items-center justify-center border-4 border-oldham-gold/30">
                      <UserIcon className="w-8 h-8 text-gray-400" />
                    </div>
                  )}
                  {/* Removed small AcademicCapIcon badge */}
                </div>
                <div>
                  <h3 className="text-lg font-bold text-white">{selectedCoach.name}</h3>
                  <p className="text-oldham-gold font-semibold text-sm whitespace-pre-line">{selectedCoach.role}</p>
                </div>
              </div>
              <button
                onClick={closeCoachModal}
                className="p-2 hover:bg-gray-700/50 rounded-full transition-colors"
              >
                <XMarkIcon className="w-6 h-6 text-gray-400" />
              </button>
            </div>

            {/* Modal Content */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Left Column */}
              <div className="space-y-6">
                {/* Credentials */}
                <div>
                  <div className="flex items-center mb-3">
                    <StarIcon className="w-5 h-5 text-oldham-gold mr-2" />
                    <span className="text-sm font-semibold text-oldham-gold">Credentials</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed">{selectedCoach.credentials}</p>
                </div>
                
                {/* Achievements */}
                <div>
                  <div className="flex items-center mb-3">
                    <TrophyIcon className="w-5 h-5 text-oldham-gold mr-2" />
                    <span className="text-sm font-semibold text-oldham-gold">Key Achievements</span>
                  </div>
                  <ul className="space-y-2">
                    {selectedCoach.achievements.map((achievement, idx) => (
                      <li key={idx} className="text-gray-300 text-sm flex items-start">
                        <span className="w-1.5 h-1.5 bg-oldham-gold rounded-full mt-2 mr-3 flex-shrink-0"></span>
                        {achievement}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              
              {/* Right Column */}
              <div>
                {/* About */}
                <div>
                  <div className="flex items-center mb-3">
                    <UserIcon className="w-5 h-5 text-oldham-gold mr-2" />
                    <span className="text-sm font-semibold text-oldham-gold">About</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed">{selectedCoach.bio}</p>
                </div>
              </div>
            </div>

            {/* Modal Footer */}
            <div className="mt-6 pt-4 border-t border-gray-700/50">
              <button
                onClick={closeCoachModal}
                className="w-full bg-oldham-gold text-gray-900 font-semibold py-3 px-6 rounded-lg hover:bg-oldham-gold/90 transition-colors"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Team;
